export default function (context, val) {
    let form = context.state.form;
    let sum = form.Sum;
    let regulars = context.state.regulars.list;
    if (!regulars.length) return;
    if (regulars.length === 1) regulars[0].sum = sum;
}